module.exports = __webpack_public_path__ + "img/headphones.a295f753.jpg";